'use client'
import React from 'react'
import { Controller } from 'react-hook-form'
import { formatDocument } from '~/helpers/documentNumber'
import FormError from '../FormError'
import { inputClass as fieldClass } from '../Input/classes'
import { LABEL_CLASS } from '../Label'

export interface IDynamicMaskedInputProps {
    name: string
    /** Sempre controlado (`Controller`): a máscara (CPF ou CNPJ) é decidida e aplicada a cada mudança do valor. */
    control: any
    labelText?: string
    placeholder?: string
    isRequired?: boolean
    className?: string
    readOnly?: boolean
}

/** CPF ou CNPJ no mesmo campo: até 11 caracteres formata como CPF, acima como CNPJ (numérico ou alfanumérico). */
const DynamicMaskedInput: React.FC<IDynamicMaskedInputProps> = ({
    name,
    control,
    labelText,
    placeholder,
    isRequired = false,
    className = '',
    readOnly = false,
}) => {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue=""
            render={({ field, fieldState }) => {
                const error = fieldState.error?.message
                const errorId = `${name}-error`
                return (
                    <div className={`form-group ${className}`}>
                        {labelText && (
                            <label
                                htmlFor={name}
                                className={`${LABEL_CLASS} ${className} ${error ? 'text-jolly-rose' : ''}`}
                            >
                                {labelText} {isRequired ? '*' : ''}
                            </label>
                        )}
                        <input
                            {...field}
                            id={name}
                            aria-invalid={error ? true : undefined}
                            aria-describedby={error ? errorId : undefined}
                            value={field.value ?? ''}
                            onChange={(e) => field.onChange(formatDocument(e.target.value))}
                            placeholder={placeholder}
                            className={`${className} ${fieldClass(Boolean(error))}`}
                            readOnly={readOnly}
                        />
                        {error && <FormError id={errorId}>{error}</FormError>}
                    </div>
                )
            }}
        />
    )
}

export default DynamicMaskedInput
